import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";

/**
 * DS Checkbox — 16×16, radius 2px.
 * 체크 시 BG/Accent (var(--ds-text-accent)), 흰 체크 아이콘.
 *
 * @param {object} props
 * @param {boolean} props.checked
 * @param {boolean} [props.indeterminate] - true 면 "-" 표시 (자식 일부만 체크된 상태)
 * @param {(checked: boolean) => void} props.onChange
 * @param {string} [props.label]
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 */
const DSCheckbox = ({
  checked,
  indeterminate = false,
  onChange,
  label,
  disabled,
  className = "",
}) => {
  // indeterminate 는 시각 표시. input.indeterminate property 도 sync 해서 a11y 호환.
  const inputRef = React.useRef(null);
  React.useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = !!indeterminate;
  }, [indeterminate]);

  const showCheck = !!checked;
  // indeterminate(일부 선택) → 채우지 않고 흰 배경 + 회색 마이너스 (figma 307:4658)
  const showMinus = !checked && !!indeterminate;

  return (
    <label
      className={`ds-checkbox ${className}`}
      style={{ position: "relative" }}
    >
      <input
        ref={inputRef}
        type="checkbox"
        className="ds-checkbox__input"
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)}
      />
      <span
        className={`ds-checkbox__box ${showCheck ? "ds-checkbox__box--checked" : ""}`}
      >
        {showCheck && <FontAwesomeIcon icon={faCheck} style={{ fontSize: 10 }} />}
        {showMinus && (
          <FontAwesomeIcon
            icon={faMinus}
            style={{ fontSize: 10, display: "block", color: "var(--ds-text-secondary)" }}
          />
        )}
      </span>
      {label != null && <span className="ds-checkbox__label">{label}</span>}
    </label>
  );
};

export default React.memo(DSCheckbox);
